import ComponentInitializer from '../libs/component-initializer.js';
import ComponentBase from './base/component-base.js';
import Splide from '@splidejs/splide';

class TargetSlider extends ComponentBase {

  private splideElement: HTMLElement;
  private splide: Splide;

  constructor(element: HTMLElement) {
    super(element);
    console.log('TargetSlider');

    this.splideElement = this.element.querySelector('.splide') as HTMLElement;
    this.splide = new Splide(this.splideElement, {
      perPage: 1,
      perMove: 1,
      gap: '10px',
    });
    this.splide.mount();
  }
}

ComponentInitializer.initializeComponent('.js-target-slider', TargetSlider);